// extracted by mini-css-extract-plugin
export default {"component":"TrustpilotBespoke__component-ycTG","background__dark":"TrustpilotBespoke__background__dark-kFNY","container":"TrustpilotBespoke__container-nQ8y"};